<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <h3>Protocolos ativos</h3>
      <SearchCollapse :expanded="false" title="Campanha">
        <toogleswitch
          style="margin-top: 10px; margin-bottom: 10px;"
          v-model="statusCampanha"
          label="Campanhas Ativas"
        />
      </SearchCollapse>
      <SearchCollapse :expanded="false" title="CRM">
        <toogleswitch
          style="margin-top: 10px; margin-bottom: 10px;"
          v-model="statusCrm"
          label="CRM Ativas"
         />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import { NxSelectPAAtendimento, NxSelectTipoFinalizacao, NxSelectResponsavelAtendimento } from '@/components/nexum/components/custom-selects/index.js'
import { NxInputName, NxInputClientWApp, NxInputDateRangeAtendimento } from '@/components/nexum/components/custom-inputs/index.js'
import toogleswitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

export default {
  name: 'SidebarSearchCentralAtendimento',
  components: { SidebarSearch, SearchCollapse, NxSelectPAAtendimento, NxInputName, NxInputClientWApp, NxSelectTipoFinalizacao, toogleswitch, NxSelectResponsavelAtendimento, NxInputDateRangeAtendimento },
  data () {
    return {
      form: {
        status: 'Aberto',
        operatorId: ['emptyOperator'],
        deptoId: ['emptyDepto'],
        botId: ['NDA'],
        page: 1,
        pageSize: 12,
        fetchImages: true
      }
    }
  },
  computed: {
    statusCampanha: {
      get () {
        return this.form.botId.includes('campanha')
      },
      set (value) {
        this.updateBotId('campanha', value)
      }
    },
    statusCrm: {
      get () {
        return this.form.botId.includes('crm')
      },
      set (value) {
        this.updateBotId('crm', value)
      }
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
        this.$emit('update-pagination')
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
        this.form.botId = ['NDA']
        this.page = 1
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    updateBotId (key, isActive) {
      let botIdSet = new Set(this.form.botId)
      if (isActive) {
        botIdSet.add(key)
      } else {
        botIdSet.delete(key)
      }
      if (botIdSet.size === 0) {
        botIdSet.add('NDA')
      }
      this.form.botId = Array.from(botIdSet)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/central_atendimento_geral/components/conversations/SidebarCentralAtendimento.vue